import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetModuleSubscriptionsAction } from '../../actions/module-subscriptions/get-module-subscriptions-action';
import { UpdateModuleSubscriptionAction } from '../../actions/module-subscriptions/update-module-subscription-action';
import { UpdateModuleSubscriptionErrorAction } from '../../actions/module-subscriptions/update-module-subscription-error-action';

@Injectable()
export class UpdateModuleSubscriptionEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public UpdateModuleSubscription = createEffect(() => this.actions
    .pipe(
      ofType(UpdateModuleSubscriptionAction.type),
      mergeMap(action => {
        const updateModuleSubscriptionAction = <UpdateModuleSubscriptionAction>action;
        return this.api.updateModuleSubscription(updateModuleSubscriptionAction.moduleSubscription).then(() => {
          return new GetModuleSubscriptionsAction(updateModuleSubscriptionAction.bijbEvent);
        }, error => {
          return new UpdateModuleSubscriptionErrorAction(error);
        });
      })
    ));
}
